import { render } from "./TreasureFoundAnimation.vue?vue&type=template&id=77b382da&scoped=true&ts=true"
import script from "./TreasureFoundAnimation.vue?vue&type=script&lang=ts"
export * from "./TreasureFoundAnimation.vue?vue&type=script&lang=ts"

import "./TreasureFoundAnimation.vue?vue&type=style&index=0&id=77b382da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b382da"]])

export default __exports__